module.exports = __webpack_public_path__ + "img/emo_27.08941d35.png";